const initialState = {};

export const reducer = (state: any = initialState, action: any) => {
    switch (action.type) {
        default:
            return state;
    }
};